import HttpService from "@/modules/core/network/http-service";

class DestinationService extends HttpService {
  constructor() {
    super("destination");
  }
}

export default new DestinationService();
